webpackJsonp([31945490039386],{

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Layout = __webpack_require__(12);
	
	var _colors = __webpack_require__(10);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;padding-bottom:10%;& ul{list-style-type:none;color:', _colors2.default.primary, ';}h1{padding-bottom:0em;padding-top:1em;}h2{font-family:Tajawal}'); /* eslint-disable no-undef, react/prop-types */
	
	
	var yhtStyle = /*#__PURE__*/(0, _reactEmotion.css)('h3{margin-top:0.5em;margin-bottom:0.5em;}// display:flex;// flex-wrap:wrap;// justify-content:space-around;');
	
	var outerImgWrapper = /*#__PURE__*/(0, _reactEmotion.css)('width:50%;min-width:5em;margin-left:auto;margin-right:auto;margin-top:2em;');
	
	var outerImgWrapper2 = /*#__PURE__*/(0, _reactEmotion.css)('width:50%;min-width:5em;margin-left:auto;margin-right:auto;margin-top:4em;');
	
	var outerImgWrapper3 = /*#__PURE__*/(0, _reactEmotion.css)('width:35%;min-width:5em;margin-left:auto;margin-right:auto;margin-top:4em;');
	
	var secondarySponsor = /*#__PURE__*/(0, _reactEmotion.css)(outerImgWrapper, ';width:35%;padding-top:1em;');
	
	var Yhteistyossa = function Yhteistyossa(_ref) {
	  var data = _ref.data;
	  var skr = data.skr,
	      taike = data.taike,
	      omavarasto = data.omavarasto,
	      arina = data.arina;
	
	  return _react2.default.createElement(
	    _Layout.Box,
	    null,
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        width: [1, 1, 1 / 2],
	        className: style,
	        m: ['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto'],
	        px: [3, 3, 0],
	        color: _colors2.default.secondary
	      },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Apurahat'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: yhtStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          alt: 'SKR',
	          outerWrapperClassName: outerImgWrapper,
	          sizes: skr.childImageSharp.sizes,
	          imgStyle: { objectFit: 'contain' }
	        }),
	        _react2.default.createElement(_gatsbyImage2.default, {
	          alt: 'TAIKE',
	          outerWrapperClassName: outerImgWrapper2,
	          sizes: taike.childImageSharp.sizes,
	          imgStyle: { objectFit: 'contain' }
	        })
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Lipunmyyntiyhteisty\xF6'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: yhtStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          alt: 'Arina',
	          outerWrapperClassName: outerImgWrapper3,
	          sizes: arina.childImageSharp.sizes,
	          imgStyle: { objectFit: 'contain' }
	        })
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Sponsorit'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: yhtStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          alt: 'Oulun Omavarasto',
	          outerWrapperClassName: secondarySponsor,
	          sizes: omavarasto.childImageSharp.sizes,
	          imgStyle: { objectFit: 'contain' }
	        })
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Peab Oy'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Glamour'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Tanssipaku'
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	exports.default = Yhteistyossa;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-yhteistyossa-js-91125088b2f437d4e3e0.js